// Calc function: XP(n) = XP(n-1) + baseGrowth + expStep × (n - 2)
export const baseGrowth = 100
export const expStep = 50

export interface LevelProgress {
  level: number
  currentExp: number
  expToCurrentLevel: number
  expToNextLevel: number
  remainingExp: number
  requiredExp: number
}

// Level by experience
export function calcLevelByExperience(experience: number): number {
  let level = 1
  while (true) {
    const nextLevelExp = getExperienceToLevel(level + 1)
    if (experience < nextLevelExp) {
      return level
    }
    level++
  }
}

// Experience to get level
export function getExperienceToLevel(level: number): number {
  if (level <= 1) return 0
  return (level - 1) * baseGrowth + ((level - 1) * (level - 2) / 2) * expStep
}

export function getExperienceProgress(experience: number): LevelProgress {
  const level = calcLevelByExperience(experience)
  const expToCurrentLevel = getExperienceToLevel(level)
  const expToNextLevel = getExperienceToLevel(level + 1)

  return {
    level,
    currentExp: experience,
    expToCurrentLevel,
    expToNextLevel,
    remainingExp: experience - expToCurrentLevel,
    requiredExp: expToNextLevel - experience,
  }
}